// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'modal',
    'quoteCompanyInput',
    'quoteNameInput',
    'quoteEmailInput',
    'userCompanyInput',
    'userFirstNameInput',
    'userLastNameInput',
    'userEmailInput',
    'form',
    'submitButton',
  ]

  connect() {
    // catch edge case where modal may cause class to persist if removed by turbo
    $('body').removeClass('modal-shown')

    if (this.data.get('open-on-connect')) {
      this.openShareModal()
    }

    window.feather.replace()
  }

  openShareModal() {
    // reset form submit button
    Rails.enableElement(this.submitButtonTarget)
    $(this.submitButtonTarget)
      .removeClass('opacity-25')
      .removeClass('pointer-events-none')

    // copy name values
    if (
      !(
        this.quoteNameInputTarget.value &&
        this.quoteNameInputTarget.value.length
      )
    ) {
      var inp = ''
      if (
        this.hasUserFirstnameInputTarget &&
        this.userFirstNameInputTarget.value &&
        this.userFirstNameInputTarget.value.length
      ) {
        inp += this.userFirstNameInputTarget.value
        if (
          this.hasUserLastNameInputTarget &&
          this.userLastNameInputTarget.value &&
          this.userLastNameInputTarget.value.length
        ) {
          inp += ' ' + this.userLastNameInputTarget.value
        }
      }
      this.quoteNameInputTarget.value = inp
    }

    // copy email address
    if (
      this.hasQuoteEmailInputTarget &&
      this.hasUserEmailInputTarget &&
      !(
        this.quoteEmailInputTarget.value &&
        this.quoteEmailInputTarget.value.length
      )
    ) {
      this.quoteEmailInputTarget.value = this.userEmailInputTarget.value
    }

    // copy company value
    if (
      this.hasQuoteCompanyInputTarget &&
      this.hasUserCompanyInputTarget &&
      !(
        this.quoteCompanyInputTarget.value &&
        this.quoteCompanyInputTarget.value.length
      )
    ) {
      this.quoteCompanyInputTarget.value = this.userCompanyInputTarget.value
    }

    $(this.modalTarget).addClass('active')
    $('body').addClass('modal-shown')
  }

  closeModal(e) {
    if (
      !$(e.target).hasClass('modal') &&
      !$(e.target).hasClass('close-modal') &&
      !$(e.target).hasClass('close-modal-btn')
    )
      return

    e.preventDefault()
    this.close()
  }

  close() {
    if (this.modalTarget.classList.contains("active")) {
      $(this.modalTarget).removeClass('active')
      $('body').removeClass('modal-shown')
    }
  }

  escClose(event) {
    if (event.key === 'Escape') this.close()
  }
}
